import { ClassNameOnlyProps } from 'module/types/common';
import { SelectMode } from 'module/ui/components/atoms/select';
import { VirtualizedMenuList } from 'module/ui/components/atoms/select/virtualized-menu-list';
import { FC, ReactNode, RefObject } from 'react';
import StateManager, {
  components as ReactSelectComponents,
} from 'react-select';
import { Popover, Select } from './components';
import { OnChangeType, OptionsType, ValueType } from '../types';

export type Props<
  IsMulti extends boolean,
  OptionValueType extends number | string = number,
> = ClassNameOnlyProps & {
  title: ReactNode;
  value: ValueType<IsMulti, OptionValueType>;
  onChange: OnChangeType<IsMulti, OptionValueType>;
  selectRef: RefObject<StateManager>;
  options: OptionsType<OptionValueType>;
  components: Partial<typeof ReactSelectComponents>;
  isMulti: IsMulti;
  type: SelectMode;
  grouped?: boolean;
};

export const getControlledSelectBasedEditorPopover =
  <
    IsMulti extends boolean,
    OptionValueType extends number | string = number,
  >(): FC<React.PropsWithChildren<Props<IsMulti, OptionValueType>>> =>
  // eslint-disable-next-line react/display-name
  ({
    title,
    onChange,
    selectRef,
    className,
    options,
    components,
    isMulti,
    value,
    type,
    grouped = false,
  }) => (
    <Popover className={className}>
      <Popover.Title>{title}</Popover.Title>
      <Select
        components={{ MenuList: VirtualizedMenuList, ...components }}
        isMulti={isMulti}
        ref={selectRef}
        options={options}
        value={value}
        onChange={onChange}
        type={type}
        grouped={grouped}
      />
    </Popover>
  );
